import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '../icons/HomeIcon';
import StatisticsIcon from '../icons/StatisticsIcon';
import ProfileIcon from '../icons/ProfileIcon';
import SettingsIcon from '../icons/SettingsIcon';
import CalcIcon from '../icons/CalcIcon';
import HelpIcon from '../icons/HelpIcon';
import EvaluationTypeModal from './EvaluationTypeModal';
import RamadanIcon from '../icons/RamadanIcon';
import PlannerIcon from '../icons/PlannerIcon';
import { BookOpenText } from 'lucide-react';

const menuItems = [
  { icon: <HomeIcon />, label: 'الرئيسية', path: '/' },
  { icon: <StatisticsIcon />, label: 'التقييم', path: '/evaluation' },
  { icon: <ProfileIcon />, label: 'المجتمع', path: '/community' },
  { icon: <SettingsIcon />, label: 'الخدمات الالكترونية', path: '/services' },
  { icon: <CalcIcon />, label: 'الحاسبة', path: '/calculator' },
  { icon: <PlannerIcon />, label: 'الخطة الأكاديمية', path: '/plan', ribbon: true, ribbonText: 'جديد' },
  { icon: <BookOpenText size={20} strokeWidth={1.9} />, label: 'شروحات الطلاب', path: '/explanations', ribbon: true, ribbonText: 'جديد' },


];

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showEvaluationModal, setShowEvaluationModal] = useState(false);

  const handleNavigation = (path) => {
    if (path === '/evaluation') {
      setShowEvaluationModal(true);
    } else {
      navigate(path);
    }
    if (window.innerWidth < 768) {
      onClose(false);
    }
  };

  const handleSelectEvaluationType = (type) => {
    if (type === 'lecturers') {
      navigate('/lecturer-evaluation');
    } else if (type === 'courses') {
      navigate('/course-evaluation');
    }
    setShowEvaluationModal(false);
  };

  return (
    <>
      <EvaluationTypeModal
        isOpen={showEvaluationModal}
        onClose={() => setShowEvaluationModal(false)}
        onSelectEvaluationType={handleSelectEvaluationType}
      />

      <div
        className={`fixed md:relative top-0 z-[100] h-screen w-full md:w-auto transition-all duration-500 ease-in-out ${
          !isOpen ? 'hidden md:block' : ''
        }`}
        style={{ direction: 'rtl' }}
        onClick={() => isOpen && onClose(false)}
      >
        <div
          className={`relative rounded-l-[36px] transition-all duration-500 ease-in-out rtl sidebar-width-control
            ${isOpen ? 'w-[240px] md:!w-[265px]' : 'w-[240px] md:!w-[80px]'}
            ${isOpen ? 'translate-x-0' : 'translate-x-full md:translate-x-0'}
            flex flex-col items-end pt-[60px] -mt-5 md:mt-0 ${!isOpen ? 'md:pt-[40px]' : ''}
            shadow-[inset_0_-1px_0_rgba(255,255,255,0.25),_inset_0_1px_0_rgba(255,255,255,0.25)]
            bg-[#081423] h-[calc(100vh-85px)] md:h-screen`}
          style={{
            '--sidebar-width': isOpen ? '100%' : '100%',
            direction: 'ltr',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="absolute inset-0 rounded-l-[36px] bg-[radial-gradient(43.64%_77.08%_at_50%_-10.42%,rgba(40,227,218,0.5)_0%,rgba(40,227,218,0)_100%)] bg-[rgba(40,227,218,0.25)] z-0" />

          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose(!isOpen);
            }}
            className={`
              absolute top-1/2 -translate-y-1/2 left-[-50px] z-[250]
              w-[50px] h-[175px] rounded-l-[45px]
              flex items-center justify-center
              border border-[#28e3da40] backdrop-blur-[6px]
              bg-[radial-gradient(43.64%_77.08%_at_50%_-10.42%,rgba(40,227,218,0.5)_0%,rgba(40,227,218,0)_100%)]
              bg-[rgba(40,227,218,0.25)]
              transition-all duration-500 ease-in-out
              border-r-0 cursor-pointer
              pointer-events-auto
              ${isOpen ? 'opacity-100' : 'opacity-0 md:opacity-100'}
            `}
          >
            <div className="w-[35px] h-[35px] flex items-center justify-center border-y-2 border-[rgba(40,227,218,0.25)] rounded-full transition-all duration-500 ease-in-out">
              <svg
                width="15"
                height="20"
                viewBox="0 0 15 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-all duration-500 ease-in-out ${isOpen ? 'rotate-180' : 'rotate-0'}`}
              >
                <path
                  d="M14.9869 18.9994V0.999426C14.9864 0.817184 14.9361 0.63855 14.8415 0.48275C14.747 0.32695 14.6118 0.199884 14.4504 0.115231C14.289 0.0305767 14.1076 -0.00845909 13.9256 0.00232315C13.7437 0.0131054 13.5682 0.0732994 13.4179 0.176426L0.417922 9.17643C-0.121078 9.54943 -0.121078 10.4474 0.417922 10.8214L13.4179 19.8214C13.5679 19.9256 13.7435 19.9867 13.9257 19.9981C14.1079 20.0094 14.2898 19.9706 14.4515 19.8859C14.6133 19.8012 14.7487 19.6738 14.8431 19.5175C14.9375 19.3612 14.9872 19.182 14.9869 18.9994Z"
                  fill="white"
                />
              </svg>
            </div>
          </button>

          <div
            className={`w-full flex justify-end mb-6 px-[20.5px] z-[120] relative ${
              !isOpen ? 'hidden md:block' : ''
            } ${!isOpen ? 'md:pr-0' : ''}`}
          >
            {!isOpen ? (
              <img src="/images/SmallLogo.png" alt="همة" className="w-[48px] h-[48px] relative z-[130]" />
            ) : (
              <img src="/images/HemaLogo.png" alt="همة" className="h-[35px] relative z-[130]" />
            )}
          </div>

          <nav className="flex flex-col items-start gap-[10px] text-white text-[12px] w-full min-h-[55%]">
            {menuItems.map((item, index) => {
              const isActive =
                item.path === location.pathname ||
                (item.path === '/evaluation' &&
                  (location.pathname === '/course-evaluation' || location.pathname === '/lecturer-evaluation'));

              return (
                <button
                  key={index}
                  onClick={() => handleNavigation(item.path)}
                  className={`relative h-[52px] w-full overflow-hidden flex flex-row-reverse items-center justify-start gap-3 px-[20.5px] py-[10px] md:px-3
                    text-white text-[12px] rounded-l-[24px] z-10 group transition-all duration-500 ease-in-out cursor-pointer
                    ${!isOpen ? 'md:justify-center md:px-2' : ''}
                    hover:bg-red-500/20`}
                >
                  <span
                    className={`
                      absolute top-0 bottom-0 left-0 right-0 rounded-l-[24px] z-0 border-[#28e3da40] bg-[#081423]
                      ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}
                      transition-all duration-500 ease-in-out
                    `}
                  />
                  <span
                    className={`
                      absolute top-0 bottom-0 left-0 right-0 rounded-l-[24px] z-0 bg-[radial-gradient(92.12%_184.55%_at_50%_-55%,rgba(40,227,218,0.2)_0%,rgba(40,227,218,0)_100%)]
                      ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}
                      transition-all duration-500 ease-in-out
                    `}
                  />
                  <span
                    className={`
                      absolute top-0 bottom-0 left-0 right-0 rounded-l-[24px] z-0 bg-[rgba(255,255,255,0.02)]
                      ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}
                      transition-all duration-500 ease-in-out
                    `}
                  />

                  {item.ribbon && isOpen && (
                    <div className="pointer-events-none absolute top-0 left-0 w-28 h-28 z-[60]">
                      <div className="absolute top-4 left-[-34px] rotate-[-45deg] w-44 bg-red-500/20 border border-red-500/40 text-red-200 text-[10px] font-bold py-1 text-center tracking-widest shadow-lg">
                        {item.ribbonText || 'برمضان فقط'}
                      </div>
                    </div>
                  )}

                  <span className="relative z-10 flex h-[32px] w-[32px] shrink-0 items-center justify-center text-white">
                    {React.cloneElement(item.icon, {
                      className: 'block shrink-0 text-white transition-colors duration-300',
                      style: {
                        ...(item.icon.props.style || {}),
                        width: 30,
                        height: 30,
                        display: 'block',
                        flexShrink: 0,
                      },
                    })}
                  </span>

                  <span className={`relative z-10 ${!isOpen ? 'hidden' : ''}`}>{item.label}</span>
                </button>
              );
            })}
          </nav>

          <div className="w-full border-t border-[#91909133] pb-[18px]">
            <button
              onClick={() => {
                try {
                  navigate('/about');
                } catch (error) {}
                if (window.innerWidth < 768) {
                  onClose(false);
                }
              }}
              className={`relative w-full flex flex-row-reverse items-center justify-center gap-[12px] h-[50px] text-white text-[12px] rounded-l-[24px] z-10 group transition-all duration-500 ease-in-out cursor-pointer px-[20.5px] py-[10px] md:px-3 ${
                !isOpen ? 'md:justify-center md:px-2' : ''
              }`}
            >
              <span
                className={`
                  absolute top-0 bottom-0 left-0 right-0 rounded-l-[24px] z-0 border-[#28e3da40] bg-[#081423]
                  ${location.pathname === '/about' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}
                  transition-all duration-500 ease-in-out
                `}
              />
              <span
                className={`
                  absolute top-0 bottom-0 left-0 right-0 rounded-l-[24px] z-0 bg-[radial-gradient(92.12%_184.55%_at_50%_-55%,rgba(40,227,218,0.2)_0%,rgba(40,227,218,0)_100%)]
                  ${location.pathname === '/about' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}
                  transition-all duration-500 ease-in-out
                `}
              />
              <span
                className={`
                  absolute top-0 bottom-0 left-0 right-0 rounded-l-[24px] z-0 bg-[rgba(255,255,255,0.02)]
                  ${location.pathname === '/about' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}
                  transition-all duration-500 ease-in-out
                `}
              />
              <span className="relative z-10 flex h-[32px] w-[32px] shrink-0 items-center justify-center">
                <HelpIcon
                  className="block shrink-0 text-white transition-colors duration-300 group-hover:text-white"
                  style={{ width: 30, height: 30, display: 'block', flexShrink: 0 }}
                />
              </span>
              <span
                className={`relative z-10 text-white text-[12px] leading-[22px] font-[Alexandria] group-hover:text-white transition-colors duration-300 ${
                  !isOpen ? 'hidden' : ''
                }`}
              >
                حول همة
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
